<template>
  <div class="comment-container">
    <img src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/all-logo2.png" class="all-logo" />
    <!-- <img class="comment-text" src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/comment/text2.png" /> -->
    <img class="comment-title" src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/comment/comment-title.png" />
    <div v-for="(item, index) in showCommentList" :key="item.id" class="comment-item cursor-pointer" :class="aniState && !showCommentModal ? 'active' : 'paused'" :style="{ left: item.left + '%', top: item.top + '%' }" @mouseenter="mouseenter" @mouseleave="mouseleave" @click="openCommentModal(item)">
      <div class="comment-show-content">
        <div class="ellipsis-4">
          <span style="color: #fff">网友{{ item.nickname }}：</span>{{ item.content }}
        </div>
      </div>
    </div>
    <div class="comment-input">
      <div class="nickname">昵称：</div>
      <input type="text" v-model="nickname" maxlength="64" placeholder="请输入" />
    </div>
    <div class="comment-content">
      <textarea v-model="content" maxlength="200" placeholder="请写下您想发布的内容，或说说您的感想。" />
      <img @click="submit" class="btn cursor-pointer" src="https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/comment/btn.png" />
    </div>
    <transition name="pop" appear>
      <div class="modal modal-mask-90" v-if="showCommentModal">
        <div class="comment-main">
          <div>
            <span style="color: #fff">网友{{ commentItem.nickname }}：</span>{{ commentItem.content }}
          </div>
          <div class="close-icon-wrap" @click="cancelCommentModal">
            <div class="close-icon" />
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
const positions = [
  { key: 1, crood: [41, 2] },
  { key: 2, crood: [57, 2] },
  { key: 3, crood: [73, 2] },
  { key: 4, crood: [40, 20] },
  { key: 5, crood: [57, 19] },
  { key: 6, crood: [74, 18] },
  { key: 7, crood: [42, 38] },
  { key: 8, crood: [59, 39] },
  { key: 9, crood: [76, 37] }
]
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { getList, publish } from '@/api/appApi.js'
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      inited: false,
      nickname: '',
      content: '',
      commentList: [],
      showCommentList: [],
      showIndex: 0,
      aniState: true,
      showCommentModal: false,
      commentItem: null,
      positionIndex: 0,
      newPositions: [],
      showPositions: []
    }
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    cancelCommentModal() {
      this.showCommentModal = false
      this.commentItem = null
    },
    openCommentModal(item) {
      this.showCommentModal = true
      this.commentItem = { ...item }
    },
    mouseleave() {
      this.aniState = true
    },
    mouseenter() {
      this.aniState = false
    },
    submit() {
      if (!this.nickname) {
        this.$emit('toast', '请输入昵称')
        return
      }
      if (!this.content) {
        this.$emit('toast', '请输入内容')
        return
      }
      const params = {
        nickname: this.nickname,
        content: this.content
      }
      this.$emit('loading', true)
      publish(params).then(res => {
        this.$emit('loading', false)
        this.$emit('toast', '提交成功，等待审核')
        this.nickname = ''
        this.content = ''
        console.log('res:', res.data)
      })
    },
    shuffleArray(array) {
      for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1))
        ;[array[i], array[j]] = [array[j], array[i]] // 交换元素
      }
      return array
    },
    handleLeft() {
      this.commentList.map(v => {
        return v
      })
    },
    generateRandomNumber(min, max, decimalPlaces) {
      var randomNumber = Math.random() * (max - min) + min
      return parseFloat(randomNumber.toFixed(decimalPlaces))
    },
    init() {
      if (this.inited) return
      this.inited = true
      console.log('comment-init')
      if (this.commentList.length <= 0) return
      this.timer = setInterval(() => {
        if (!this.aniState) return
        if (this.showCommentModal) return
        if (this.showIndex >= this.commentList.length) {
          this.showIndex = 0
        }
        if (this.positionIndex >= this.newPositions.length) {
          this.positionIndex = 0
          // this.newPositions = this.shuffleArray(positions)
        }
        const item = this.commentList[this.showIndex]
        // 判断是否有该元素
        const _delIndex = this.showCommentList.findIndex(v => v.id === item.id)
        if (_delIndex !== -1) {
          // 需要先删除
          this.showCommentList.splice(_delIndex, 1)
        }
        item.left = this.newPositions[this.positionIndex].crood[0]
        item.top = this.newPositions[this.positionIndex].crood[1]
        this.showCommentList.push(item)
        this.showIndex++
        this.positionIndex++
      }, 2000)
      // console.log(this.showCommentList)
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  async created() {
    const res = await getList({ page: 1, page_size: 9999 })
    this.commentList = res.data
    console.log(this.commentList)
    console.log(this.newPositions)
    this.newPositions = this.shuffleArray(positions)
    // this.init()
    // getList({ page: 1, page_size: 9999 }).then(res => {
    //   // console.log('res:', res.data)
    //   this.commentList = res.data
    //   console.log(this.commentList)
    // })
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    // this.init()
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  }, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss" scoped>
$originWidth: 1920;
$originHeight: 919;
.comment-container {
  background-image: url('https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/comment/bg12.jpg'); /* 替换成你的图片地址 */
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
  height: 100vh;
  overflow: hidden;

  .all-logo {
    position: absolute;
    width: percentage(288 / $originWidth);
    height: percentage(41 / $originHeight);
    left: percentage(1574 / $originWidth);
    top: percentage(73 / $originHeight);
  }

  .comment-main {
    width: 30%;
    background-color: #812a19;
    color: #ffee9e;
    padding: 20px 18px;
    border-radius: 8px;
    line-height: 30px;
    font-size: 20px;
    position: relative;
    font-family: '楷体', '楷体_GB2312';
    .close-icon-wrap {
      position: absolute;
      left: calc(50% - 12px);
      bottom: -60px;
      background-color: #00000090;
      border-radius: 50%;
      padding: 8px;
      cursor: pointer;
    }
    .close-icon {
      width: 24px;
      height: 24px;
      background: url('https://static.yl.nbwbw.com/uploads/activity/h5/jtwfb/close.png') no-repeat;
      background-size: 100% 100%;
    }
  }
  textarea {
    background: none;
    outline: none;
    border: 0px;
    width: 100%;
    height: 100%;
    resize: none;
    font-size: 20px;
    color: #812a19;
  }
  input {
    background: none;
    outline: none;
    border: 0px;
    width: 100%;
    font-size: 20px;
    color: #812a19;
  }

  .comment-title {
    position: absolute;
    width: percentage(804 / $originWidth);
    height: percentage(50 / $originHeight);
    left: percentage(862 / $originWidth);
    top: percentage(470 / $originHeight);
  }
  .comment-input {
    padding: 0 12px;
    box-sizing: border-box;
    position: absolute;
    display: flex;
    align-items: center;
    border: 3px solid #812a19;
    width: percentage(804 / $originWidth);
    height: percentage(54 / $originHeight);
    left: percentage(862 / $originWidth);
    top: percentage(517 / $originHeight);
    box-shadow: inset 0px 0px 10px 0px rgba(0, 0, 0, 0.004);
    background-color: #fff;
    font-size: 20px;
    color: #812a19;
    .nickname {
      flex-shrink: 0;
    }
  }
  .comment-content {
    padding: 12px;
    box-sizing: border-box;
    position: absolute;
    border: 3px solid #812a19;
    width: percentage(804 / $originWidth);
    height: percentage(192 / $originHeight);
    left: percentage(862 / $originWidth);
    top: percentage(596 / $originHeight);
    box-shadow: inset 0px 0px 10px 0px rgba(0, 0, 0, 0.004);
    background-color: #fff;
    position: relative;
  }
  @keyframes moveAndDisappear {
    0% {
      top: 54.629%; /* 起始位置在屏幕底部以下 */
      opacity: 0;
    }
    30% {
      top: 35%;
      opacity: 1;
    }
    50% {
      top: 25%; /* 中间位置在屏幕高度的50% */
      opacity: 1;
    }
    75% {
      top: 15%; /* 中间位置在屏幕高度的50% */
      opacity: 1;
    }
    100% {
      top: 5%; /* 结束位置在屏幕顶部以上 */
      opacity: 0;
    }
  }
  @keyframes pop-up {
    0% {
      transform: scale(0);
      opacity: 0;
    }
    6% {
      transform: scale(1);
      opacity: 1;
    }
    50% {
      transform: scale(1);
      opacity: 1;
    }
    94% {
      transform: scale(1);
      opacity: 1;
    }
    100% {
      transform: scale(0);
      opacity: 0;
    }
  }
  .comment-item {
    // animation: moveAndDisappear 10s infinite;
    animation: pop-up 10s linear forwards;
    position: absolute;
    // top: 54.629%;
    width: percentage(296 / $originWidth);
    .comment-show-content {
      border-radius: 24px;
      padding: 5% 5%;
      font-size: 20px;
      min-height: 60px;
      background-color: #bc714d;
      color: #ffee9e;
      line-height: 26px;
      font-family: '楷体', '楷体_GB2312';
      // white-space: pre-wrap;
      &::before {
        content: '';
        position: absolute;
        bottom: -40px;
        left: calc(50% - 20px); /* 三角形宽度的一半 */
        border-width: 20px;
        border-style: solid;
        border-color: #bc714d transparent transparent transparent;
      }
    }
  }
  .active {
    animation-play-state: running;
  }
  .paused {
    animation-play-state: paused;
  }
  .comment-text {
    position: absolute;
    width: percentage(640 / $originWidth);
    height: percentage(408 / $originHeight);
    left: percentage(149 / $originWidth);
    top: percentage(283 / $originHeight);
  }
  .btn {
    position: absolute;
    width: 22%;
    height: 22%;
    right: 0;
    bottom: 0;
  }
  .comment-input-title {
    position: absolute;
    width: 100%;
    background-color: #812a19;
    left: -3px;
    color: #ffee9e;
    text-align: center;
    border-top-left-radius: 30px;
    border-top-right-radius: 30px;
    top: -30px;
    height: 30px;
    line-height: 30px;
    border: 3px solid #812a19;

    span {
      font-family: '楷体', '楷体_GB2312';
      margin: 0 24px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Comment/index.vue